export default __webpack_public_path__ + "static/media/CS-RaceWeek-Brasil(360x600).95acc06c.webp";